import { Nullable } from '@/core/interfaces/common';

interface Validator {
  (value: Nullable<string>): string | undefined;
}

export const isEmail = (value: Nullable<string>) => (
  value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
    undefined :
    'This is not a valid email'
);

export const required = (value: Nullable<string>) => (value ? undefined : 'This Field is Required');

export const composeValidators = (
  ...validators: Array<Validator>
) => (value: string) => (
  validators.reduce(
    (error: string | undefined, validator: Validator) => error || validator(value), undefined
  )
);

export const phoneNumberValidator = (value: Nullable<string>) => (
  value && /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ?
    undefined :
    'This is not a valid phone number'
);

export const minLengthValidator = (length: number, minLength: number, field = 'Field') => (
  length < minLength ? `${field} must be longer than ${minLength - 1} characters.` : ''
);
